import React from "react";
import "../styles/whatsapp.css";

export default function WhatsAppButton({ phone, text, show = true }) {
  if (!show) return null;
  const href = `https://wa.me/${phone}?text=${encodeURIComponent(text || "")}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      aria-label="WhatsApp"
      title="Chateá por WhatsApp"
    >
      {/* Ícono SVG inline (no dependés de imágenes externas) */}
      <svg viewBox="0 0 32 32" className="whatsapp-icon" aria-hidden="true">
        <path d="M19.11 17.21c-.27-.14-1.57-.77-1.81-.86-.24-.09-.42-.14-.6.14-.18.27-.69.86-.84 1.03-.16.18-.31.2-.58.07-.27-.14-1.12-.41-2.13-1.32-.79-.7-1.32-1.56-1.47-1.82-.15-.27-.02-.41.11-.55.11-.11.24-.27.36-.41.12-.14.16-.23.24-.39.08-.16.04-.3-.02-.41-.06-.11-.6-1.44-.82-1.97-.22-.53-.44-.45-.6-.46-.16-.01-.34-.01-.52-.01-.18 0-.48.07-.73.34-.25.27-.96.94-.96 2.29 0 1.35.99 2.65 1.13 2.83.14.18 1.95 2.98 4.73 4.16.66.29 1.17.46 1.57.59.66.21 1.26.18 1.73.11.53-.08 1.57-.64 1.79-1.26.22-.62.22-1.15.15-1.26-.06-.11-.24-.18-.51-.32zM16.02 3.2c-7.05 0-12.77 5.72-12.77 12.77 0 2.25.59 4.37 1.62 6.21L3.2 28.8l6.79-1.64c1.79.98 3.84 1.54 6.03 1.54 7.05 0 12.77-5.72 12.77-12.77S23.07 3.2 16.02 3.2zm0 23.14c-1.93 0-3.73-.58-5.23-1.56l-.38-.24-4.02.97.96-3.92-.25-.4a9.99 9.99 0 0 1-1.58-5.3c0-5.54 4.5-10.04 10.04-10.04s10.04 4.5 10.04 10.04-4.5 10.04-10.04 10.04z"/>
      </svg>
    </a>
  );
}
